

const state = {
  batteryList:"",
  exchangeList:"",
  leaseList:"",
  siteList:"",
  billingList:"",
  clientList:"",

}
let listName=''
function  init(listName) {
  state[listName]=JSON.parse( localStorage.getItem(listName));
}
init(listName);
const mutations = {
  CHANGE_SETTING: (state, { key, value }) => {
    if (state.hasOwnProperty(key)) {
      localStorage.setItem(key,JSON.stringify(value));
      state[key] = value
    }
  }

}

const actions = {
  changeSetting({ commit }, data) {
    listName=data.key
    commit('CHANGE_SETTING', data)
    
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}




// WEBPACK FOOTER //
// ./src/store/modules/column.js